function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext, useCallback } from "react";
import { RadioContext, getInputProps } from "./RadioGroup";
import { onRadioKeyPress } from "../../helpers";
import { useId } from "../../helpers/hooks";
export default function useRadio() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const id = useId();
  const labelId = `texada-ui-custom-radio-${id}`;
  const context = useContext(RadioContext);
  const inputProps = getInputProps(context, props);
  const RadioLabel = useCallback(labelProps => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", _extends({
    htmlFor: labelId,
    children: props.label,
    onClick: e => e.stopPropagation()
  }, labelProps)), /*#__PURE__*/React.createElement("input", _extends({
    style: {
      display: "none"
    },
    id: labelId,
    tabIndex: "-1",
    type: "radio"
  }, inputProps))));
  RadioLabel.displayName = "RadioLabel";
  return {
    id: labelId,
    checked: inputProps.checked,
    RadioLabel,
    radioProps: {
      role: "radio",
      "aria-checked": inputProps.checked,
      tabIndex: inputProps.disabled ? -1 : 0,
      onKeyPress: onRadioKeyPress(labelId),
      onClick: () => document.querySelector(`#${labelId}`).click()
    }
  };
}
//# sourceMappingURL=useRadio.js.map